import { render, staticRenderFns } from "./RadioOkNg.vue?vue&type=template&id=18b8286b&scoped=true&lang=pug&"
import script from "./RadioOkNg.vue?vue&type=script&lang=ts&"
export * from "./RadioOkNg.vue?vue&type=script&lang=ts&"
import style0 from "./RadioOkNg.vue?vue&type=style&index=0&id=18b8286b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b8286b",
  null
  
)

export default component.exports